// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { RapidReviewContactLensPrescriptionResponse } from './rapid-review-contact-lens-prescription-response';

// @ts-ignore
import { RapidReviewContactLensTrialResponse } from './rapid-review-contact-lens-trial-response';

// @ts-ignore
import { RapidReviewEyeglassPrescriptionResponse } from './rapid-review-eyeglass-prescription-response';

// @ts-ignore
import { RapidReviewWorkflowTestResponse } from './rapid-review-workflow-test-response';

/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewExamRecapResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewExamRecapResponse extends GandalfModelBase {

	@GandalfArray(RapidReviewContactLensPrescriptionResponse)
	contactLensPrescriptions!: RapidReviewContactLensPrescriptionResponse[];

	@GandalfArray(RapidReviewContactLensTrialResponse)
	contactLensTrials!: RapidReviewContactLensTrialResponse[];

	@GandalfProperty({ designType: Number })
	encounterId!: number;

	@GandalfArray(RapidReviewEyeglassPrescriptionResponse)
	eyeglassPrescriptions!: RapidReviewEyeglassPrescriptionResponse[];

	@GandalfArray(RapidReviewWorkflowTestResponse)
	worflowTests!: RapidReviewWorkflowTestResponse[];

}
